export default "/images/vendor/flag-icon-css/flags/4x3/cv.svg?fe0c56194b4f20b42ab27952dedcb217";